<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <template slot="header">
          <h4 class="card-title">Best Australia Betting Companies Lists</h4>
        </template>
        <div>
          <form method="#" action="#" @submit.prevent="updateNews" onSubmit="document.getElementById('submit').disabled=true;"  class="form-horizontal">
            <div class="row">
              <label class="col-sm-2 col-form-label">Name</label>
              <div class="col-sm-4">
                <fg-input v-model="name" type="text" placeholder="Name">
                </fg-input>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-2 col-form-label">Site Link</label>
              <div class="col-sm-4">
                <fg-input v-model="siteLink" type="text" placeholder="Site Link">
                </fg-input>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-2 col-form-label">Review Link</label>
              <div class="col-sm-4">
                <fg-input v-model="reviewLink" type="text" placeholder="Review Link">
                </fg-input>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-2 col-form-label">Logo</label>
              <div class="col-sm-4">
                <!-- <fg-input v-model="imageURL" type="text" placeholder="Image URL">
                </fg-input> -->
                <el-upload class="picture"
                     action="https://jsonplaceholder.typicode.com/posts/"
                     :on-change="handlePreview"
                     :auto-upload="false"
                     :show-file-list="false">
                    <img v-if="model.imageUrl" :src="model.imageUrl" class="picture-src">
                </el-upload>
              </div>
            </div>

     
            <div class="row">
              <label class="col-sm-2 col-form-label"></label>
              <div class="col-sm-4">
                <n-button class="btn-block" native-type="submit" type="primary" id='submit' round>
                Edit
              </n-button>
              <n-button class="btn-block" @click.native="deleteNews" type="default" round>
                Delete
              </n-button>
              </div>
            </div>
          </form>
        </div>
      </card>  <!-- end card -->
    </div>
  </div>
</template>
<script>
import { Checkbox, Radio } from 'src/components/index';
import {
  TimeSelect,
  DatePicker,
  Tag,
  Input,
  Button,
  Select,
  Option
} from 'element-ui';

import db from '@/components/firebaseInit'
import firebase from 'firebase';
import { Upload } from 'element-ui'; 


export default {
  components: {
    Checkbox,
    Radio,
    [Option.name]: Option,
    [Select.name]: Select,
    [Upload.name]: Upload
  },
  data() {

    return {
      item_id: null,
      name: null,
      siteLink: null,
      catagory: null,
      title: null,
      content: null,
      link: null,
      reviewLink: null,
      date: null,
      imageUrl: null,
      uploadValue: null,
      picture: null,
      imageData: null,
      model: {
          imageUrl: 'img/image_placeholder.jpg'
      }
    };
  },

    beforeRouteEnter(to, from, next) {
    db
      .collection('bestUsBettingSites').where(firebase.firestore.FieldPath.documentId(), '==', to.params.item_id)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          next(vm => {
            vm.id = doc.id;
            vm.name = doc.data().name;  
            vm.siteLink = doc.data().siteLink;
            vm.reviewLink = doc.data().reviewLink;
            vm.picture = doc.data().logo;
            vm.model.imageUrl = doc.data().logo;
          });
        });
      });
  },
   watch: {
    $route: 'fetchData'
  },
    methods: {

        handlePreview(file) {
        this.model.imageUrl = URL.createObjectURL(file.raw);
        this.imageData = event.target.files[0];
        },
        getError(fieldName) {
        return this.errors.first(fieldName);
        },
        validate() {
        return this.$validator.validateAll().then(res => {
            this.$emit('on-validated', res, this.model);
            return res;
        });
        },

    fetchData () {
      db.collection('bestUsBettingSites')
        .where(firebase.firestore.FieldPath.documentId(), '==', this.$route.params.item_id)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.id = doc.id;
            this.name = doc.data().name;  
            this.siteLink = doc.data().siteLink;
            this.reviewLink = doc.data().reviewLink;
            this.picture = doc.data().logo;
            this.model.imageUrl = doc.data().logo;
          });
        });
    },
        updateNews () {

if(this.imageData == null){

         db.collection('bestUsBettingSites').where(firebase.firestore.FieldPath.documentId(), '==', this.$route.params.item_id).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            doc.ref.update({
                    name: this.name,
                    siteLink: this.siteLink,
                    reviewLink: this.reviewLink,
                    logo: this.picture

            })
            .then(() => {
              console.log('News have been Updated')
              alert("Succefully Updated latest Predictions");
              this.$router.push('/sidebar/bestUSA')
            });
          })
        })

}else{

      this.picture=null;
      let timename = Date.now();
      const storageRef=firebase.storage().ref(`${timename}`).put(this.imageData);
      storageRef.on(`state_changed`,snapshot=>{
        this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
      }, error=>{console.log(error.message)},
      ()=>{this.uploadValue=100;
        storageRef.snapshot.ref.getDownloadURL().then((url)=>{
          this.picture =url;
        //   console.log(this.picture);


        db.collection('bestUsBettingSites').where(firebase.firestore.FieldPath.documentId(), '==', this.$route.params.item_id).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            doc.ref.update({
                    name: this.name,
                    siteLink: this.siteLink,
                    reviewLink: this.reviewLink,
                    logo: this.picture

            })
            .then(() => {
              console.log('News have been Updated')
              alert("Succefully Updated latest Predictions");
              this.$router.push('/sidebar/bestUSA')
            });
          })
        })



        });
      }
      );


}



      
      
      },
      deleteNews() {
        if (confirm('Are you sure?')) {

            // Delete the Show
            db
            .collection('bestUsBettingSites')
            .where(firebase.firestore.FieldPath.documentId(), '==', this.$route.params.item_id)
            .get()
            .then(querySnapshot => {
                querySnapshot.forEach(doc => {
                doc.ref.delete();
                console.log('News Deleted')
                alert("Succefully Deleted Blog");                
                this.$router.push('/sidebar/bestUSA');
                });
            });
        }
    }

  }




};
</script>
<style>
</style>
